/** @type {import('./$types').PageLoad} */
export function load({ data }) {
	return data;   // just pass through – crawlers already have everything
}
